import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { ClientServicingCss as Styles } from "./css/ClientServicingCss";
import ReactPlayer from "react-player";

export default function Hero(props: any) {
    const classes = Styles();
    const { clientDetail } = props;
    let clientFullName: string = '';
    if(clientDetail && clientDetail.payload) {
        clientFullName = clientDetail.payload.firstName + " " + clientDetail.payload.lastName;
    }
    return (
            <div className={classes.containerWidth1700}>
                <div className={classes.agentHero}>
                    <Grid container spacing={2} alignItems="center" >
                        <Grid item xs={12} md={12} lg={6} xl={7}>
                            <Typography variant="h2" align="left" className={classes.colorWhite + " " + classes.title + " mt40md "}>
                                Welcome {clientFullName}
                            </Typography>
                            <Typography variant="subtitle1"
                                        className={classes.colorWhite + " " + classes.mb0 + " " + classes.floatLeft}>
                                Now that you’ve successfully enrolled you will be able to view and manage your
                                policy here.
                                You can view documents, make a yearly contribution payment, file a claim, change
                                your
                                details, and get answers to your policy questions.
                            </Typography>
                        </Grid>
                        <Grid  item xs={12} md={12} lg={6} xl={5} alignContent="center">
                            <ReactPlayer
                                    className="serviceHeroVideo"
                                    controls={true}
                                    playing={false}
                                    loop={true}
                                    autoPlay={true}
                                    volume={0}
                                    muted={true}
                                    url={"https://player.vimeo.com/video/817319011"}
                                    width="100%"
                                    playsinline={true}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
    );
}